export enum ToastType {
  info = 'info',
  success = 'success',
  error = 'error',
}
